module.exports = __webpack_public_path__ + "img/menu-icon-chat-circle.efa91e5c.svg";